/**
 * @Author: Zero
 * @Date: 2024-09-29 14:07:41
 * @Explain: 联系人报表
 */
import http from '../http';

const MODEL = '/contact_report';

export default {
  // 过滤记录 - 查重名
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取过滤记录
  getFilterList(data: Record<any, any>) {
    return http.post(`${MODEL}/filters_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 过滤记录 - 新增
  onAddFilter(data: Record<any, any>) {
    return http.post(`${MODEL}/add_filter`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 过滤记录 - 编辑
  onEditFilter(data: Record<any, any>) {
    return http.post(`${MODEL}/edit_filters`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 过滤记录 - 删除
  onDelFilter(data: Record<any, any>) {
    return http.post(`${MODEL}/del_filters`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 筛选器校验
  onVerifyFilter(data: Record<any, any>) {
    return http.post(`${MODEL}/verify_condition`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取评级
  getRatingList(data: Record<any, any>) {
    return http.post(`${MODEL}/get_rating`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取关键指标模块说明
  getKeyMetrics(data: Record<any, any>) {
    return http.post(`${MODEL}/key_metrics`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人变化
  getContactsTrend(data: Record<any, any>) {
    return http.post(`${MODEL}/contacts_trend`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人分布 - 订阅状态分布
  getContactsSubscription(data: Record<any, any>) {
    return http.post(`${MODEL}/contacts_distributed`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人分布 - 偏好分布
  getContactsPreference(data: Record<any, any>) {
    return http.post(`${MODEL}/preference`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人分布 - 来源分布
  getContactsSources(data: Record<any, any>) {
    return http.post(`${MODEL}/source`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人分布 - 语言分布
  getContactsLanguages(data: Record<any, any>) {
    return http.post(`${MODEL}/language`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取联系人分布 - 地区分布
  getContactsLocations(data: Record<any, any>) {
    return http.post(`${MODEL}/region`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
